const customOrderTypes = [
	{value: 0, label: 'Pasif'},
	{value: 1, label: 'Aktif OTP\'li'},
	{value: 2, label: 'Aktif OTP\'siz'},
]

export default customOrderTypes